module.exports = __webpack_public_path__ + "img/SIE.3256f279.jpg";